module.exports = __webpack_public_path__ + "img/img21.946b0855.png";